import tingle from 'tingle.js'

window.rentProduct = (element) => {
  var modal = new tingle.modal({
    footer: true,
    stickyFooter: false,
    closeMethods: ['overlay', 'button', 'escape'],
    closeLabel: "Close",
  });
  modal.setContent('<div class="text-center"><i class="fas fa-spinner fa-spin"></i></div>');
  const url = element.getAttribute('data-href');
  const http = new XMLHttpRequest();
  http.open("GET", url);
  http.send();
  modal.open();
  http.onload = () => {
    window.redrawSubmitForm(http.responseText, modal);
  };
  return false;
};

window.redrawSubmitForm = (htmlContent, modal) => {
  modal.setContent(htmlContent);
  modal.setFooterContent('');
  modal.addFooterBtn('Zavřít', 'btn outline', function () {
    modal.close();
  });
  modal.addFooterBtn('ZAREZERVOVAT', 'btn', function () {
    var form = document.getElementById('rent').parentElement;
    modal.setFooterContent('');
    modal.setContent('<div class="text-center"><i class="fas fa-spinner fa-spin"></i></div>');
    window.submitRentForm(form, (result) => {
      if (result.hasOwnProperty('response')) {
        modal.setContent(result['response']);
        modal.setFooterContent('');
        modal.addFooterBtn('OK', 'btn outline', function () {
          modal.close();
        });
      } else {
        window.redrawSubmitForm(result['redraw'], modal);
      }
    });
  });
};

window.submitRentForm = (form, result) => {
  const url = form.getAttribute('async-action');
  const http = new XMLHttpRequest();
  http.open("POST", url);
  http.send(new FormData(form));
  http.onload = () => {
    result(JSON.parse(http.responseText))
  }
};

